import "./i18n"

import * as Sentry from "@sentry/react"

import App from "./App"
import { createRoot } from "react-dom/client"

Sentry.init({
  dsn: "https://a05db95880814688b83dfcdf382e30ff@o1282255.ingest.sentry.io/6489534",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
})

const container = document.getElementById("app")
const root = createRoot(container)
root.render(<App />)
